import { axios } from "utils";

import { PUBLIC_FARMS_URL as endpoint } from "consts";

import {
  AddFarmDetailsRequest,
  AddOrUpdateFarmDetailsResponse,
  DataSubmissionDatesResponse,
  FarmDataSubmissionStatusResponse,
  FarmDetailsResponse,
  FarmPaymentItemsResponse,
  FarmPaymentsResponse,
  FarmResponse,
  UpdateFarmDetailsRequest,
} from "models";

// this file and endpoints should be refactored!
// every endpoint should have a prefix such as farm/field/shape/etc
// move base endpoint to constants

// farms

export const addFarm = async ({ farmDetails }: { farmDetails: AddFarmDetailsRequest }): Promise<AddOrUpdateFarmDetailsResponse> =>
  axios.post(`${endpoint}`, { data: farmDetails });

export const getFarms = async (): Promise<FarmResponse[]> => axios.get(`${endpoint}`);

export const getFarmDetails = async ({ farmId }: { farmId: string }): Promise<FarmDetailsResponse> => axios.get(`${endpoint}/${farmId}`);

export const updateFarmDetails = async ({ farmDetails }: { farmDetails: UpdateFarmDetailsRequest }): Promise<AddOrUpdateFarmDetailsResponse> =>
  axios.put(`${endpoint}/${farmDetails.id}`, { data: farmDetails });

export const deleteFarm = async ({ password, farmId }: { password: string; farmId: string }) => axios.delete(`${endpoint}/${farmId}`, { data: { password } });

// points and payment

export const getBankingDetails = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/banking-details`, { data });

export const updateBankingDetails = async (data: { signal: AbortSignal }) => axios.put(`${endpoint}/banking-details`, { data });

export const getFarmPayments = async (data: { signal: AbortSignal }): Promise<FarmPaymentsResponse> => axios.get(`${endpoint}/payments`, { data });

export const getFarmPaymentItems = async (): Promise<FarmPaymentItemsResponse[]> => axios.get(`${endpoint}/payment-items`);

export const generateCreditNote = async (data: { token: string; signal: AbortSignal }) => axios.get(`${endpoint}/credit-note/${data.token}`, { data });

export const getAllFarmManagementTools = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/farm-management-tools`, { data });

// data submission

export const addFarmDataSubmission = async (data: { farmId: string }): Promise<{ success: boolean; message: string }> =>
  axios.post(`${endpoint}/submissions`, { farmId: data.farmId });

export const getFarmDataSubmissionStatus = async (data: { farmId: string; signal: AbortSignal }): Promise<FarmDataSubmissionStatusResponse> =>
  axios.get(`${endpoint}/submissions/${data.farmId}`, { signal: data.signal });

export const getFarmReportingYear = async (): Promise<number> => axios.get(`${endpoint}/reporting-year`);

export const getDataSubmissionDates = async (): Promise<DataSubmissionDatesResponse> => axios.get(`${endpoint}/data-submission-dates`);
